import api from "api";
import { useMutation } from "react-query";

const useCloseTherapistAccount = () => useMutation((id: number) => api("POST /therapists/{id}/close", [id]));

export default useCloseTherapistAccount;
